var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h4',{staticClass:"display-1 font-weight-black pt-6 grey--text text--lighten-1"},[_vm._v("\n    "+_vm._s(_vm.subtitle)+"\n  ")]),_c('h3',{staticClass:"display-2 font-weight-medium pb-4"},[_vm._v(_vm._s(_vm.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }